<div class="body">
  <mat-toolbar class="toolbar">
    <div class="menu d-print-none">
      <button mat-icon-button class="noOutline" (click)="toggleSidenav()">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
    <!-- Title and Version -->
    <div class="full-width">
      <div class="row full-width">
        <div class="col-sm-12 col-md-2 d-print-none d-flex align-items-center">
          <span class="toolbar-title">{{ moduleTitle }}</span>
        </div>
        <div class="col-sm-12 col-md-10 pt-1em">
          <div class="row">
            <div class="col p-1 d-flex justify-content-between">
              <div class="type-header d-flex flex-column">
                <span>
                  <h1 [ngClass]="version?.statusClass" id="serialNumber">
                    {{ version?.name }}
                  </h1>
                </span>
                <span
                  *ngIf="version"
                  class="status"
                  [ngClass]="version.statusClass"
                >
                  {{ version.statusName }}
                </span>
              </div>

              <div class="d-flex align-items-center">
                <div *ngIf="version" class="d-flex gap-1 small">
                  Global Template: <b>{{ globalTemplate }}</b
                  ><mat-icon
                    class="green"
                    *ngIf="version && version.wfTableConfig?.status == 1"
                    >check_circle</mat-icon
                  ><mat-icon
                    class="red"
                    *ngIf="version && version.wfTableConfig?.status != 1"
                    >update</mat-icon
                  >
                </div>
              </div>
            </div>
            <div class="col p-1 pr-3 d-flex justify-content-end">
              <div *ngIf="version" class="d-flex align-items-center">
                <div class="d-flex flex-column text-right">
                  <div
                    class="small float-right nowrap"
                    *ngIf="version.updatedByName"
                  >
                    Last update by: <b>{{ version.updatedByName }}</b
                    >&nbsp;on:
                    <span class="date">{{
                      version.updatedOn | date: "short"
                    }}</span>
                  </div>
                  <div class="small float-right" *ngIf="version.approvedBy">
                    Approved by: <b>{{ version.approvedBy.name }}</b
                    >&nbsp;on:
                    <span class="date">{{
                      version.approvedOn | date: "short"
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-toolbar>
  <!-- Sidenav and Main Content -->
  <mat-sidenav-container
    class="sidenav-container mat-sidenav-collapse-transition"
    autosize
  >
    <mat-sidenav
      [ngClass]="{ 'mat-sidenav-collapsed': !isExpanded && !isShowing }"
      #sidenav
      opened="true"
      class="d-print-none"
      mode="side"
      (mouseenter)="mouseenter()"
      (mouseleave)="mouseleave()"
    >
      <!-- Section 1 -->
      <mat-nav-list>
        <!-- Table -->
        <mat-list-item style="height: unset">
          <div [ngClass]="{ invisible: !isExpanded && !isShowing }">
            <absi-builder-side
              [version]="version"
              (selectedRow)="selectedRow($event)"
              (selectedType)="selectedType($event)"
            ></absi-builder-side>
          </div>
        </mat-list-item>
      </mat-nav-list>

      <!-- Section 2 -->
      <mat-nav-list id="left-nav-buttons">
        <mat-list-item
          (click)="create()"
          class="parent"
          *ngIf="
            hasPrivilege(privilegeEnum.CreateABSITemplate) &&
            type
          "
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Create New</span
          >
          <mat-icon matListItemIcon class="yellow">add_box</mat-icon>
        </mat-list-item>

        <mat-list-item
          (click)="duplicate()"
          class="parent"
          *ngIf="
            version &&
            hasPrivilege(privilegeEnum.CreateABSITemplate) &&
            version.statusName !== 'New'
          "
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Duplicate Template</span
          >
          <mat-icon matListItemIcon class="blue">content_copy</mat-icon>
        </mat-list-item>
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="d-flex flex-column justify-content-between">
        <div
          class="sidenav-content"
          [ngClass]="{
            amendment: false,
          }"
        >
          <checklist-builder-reject
            [errorMessages]="errorMessages ?? []"
            *ngIf="checkErrors()"
          >
          </checklist-builder-reject>
          <absi-builder-main [version]="version"></absi-builder-main>
        </div>

        <absi-builder-buttons
          [version]="version"
          (canceled)="delete()"
          (approved)="approve()"
          [disabled]="hasErrors"
        ></absi-builder-buttons>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
